/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrderClass } from '../../models/order-class';

export interface OrderClassGetorderclass$Params {
  patientId?: string | null;
  emrpracticeId?: string | null;
}

export function orderClassGetorderclass(http: HttpClient, rootUrl: string, params?: OrderClassGetorderclass$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OrderClass>>> {
  const rb = new RequestBuilder(rootUrl, orderClassGetorderclass.PATH, 'get');
  if (params) {
    rb.query('patientId', params.patientId, {});
    rb.query('emrpracticeId', params.emrpracticeId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<OrderClass>>;
    })
  );
}

orderClassGetorderclass.PATH = '/orderclass/list';
